import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { Button } from '@/components/ui/button'

const CONSENT_KEY = 'sycek_cookie_consent'

export default function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY)
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 1200)
      return () => clearTimeout(t)
    }
  }, [])

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    setVisible(false)
  }

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] p-4">
      <div
        className="max-w-5xl mx-auto rounded-xl border border-green-500/40 bg-[#0d1a0d]/95 backdrop-blur-md shadow-2xl shadow-green-500/20 px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 animate-in slide-in-from-bottom-4 duration-300"
      >
        {/* Cookie icon */}
        <div className="w-9 h-9 flex-shrink-0 rounded-lg bg-green-500/10 border border-green-500/30 flex items-center justify-center">
          <span className="text-lg">🍪</span>
        </div>

        {/* Text */}
        <p className="flex-grow text-sm text-gray-300 leading-relaxed">
          We use cookies and similar technologies to keep you signed in, analyse usage, and personalise content.
          By clicking <strong className="text-white">Accept All</strong>, you agree to our{' '}
          <Link to="/privacy-policy" className="text-green-400 hover:text-green-300 underline underline-offset-2 transition-colors">
            Privacy Policy
          </Link>{' '}
          and{' '}
          <Link to="/terms-of-service" className="text-green-400 hover:text-green-300 underline underline-offset-2 transition-colors">
            Terms of Service
          </Link>.
        </p>

        {/* Actions */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <Button
            variant="outline"
            size="sm"
            onClick={decline}
            className="border-gray-600/60 text-gray-400 hover:bg-gray-800 hover:text-white text-xs h-8 px-3"
          >
            Decline
          </Button>
          <Button
            size="sm"
            onClick={accept}
            className="bg-green-500 hover:bg-green-600 text-black font-semibold text-xs h-8 px-4 shadow-lg shadow-green-500/30"
          >
            Accept All
          </Button>
          <button
            onClick={decline}
            aria-label="Dismiss"
            className="ml-1 text-gray-500 hover:text-gray-300 transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  )
}
